<template>
  <div class="news-page page">
    <div class="page-header page-header-center">
      <h1 class="title">Latest News</h1>
      <p class="subtitle">
        Get the latest news and review recent updates
      </p>
      <div class="help">
        <img src="../assets/img/help.svg"/>
        <span class="text">
          <span class="prompt">Need help?</span>
          <el-link type="info">
            Click me
          </el-link>
        </span>
      </div>
    </div>

    <el-row :gutter="20">
      <el-col>
        <el-card
          v-for="(release, index) in releases"
          class="release"
          shadow="hover"
          :key="index"
        >
          <div class="release-version is-left">
            <div class="release-version-number">
              {{ release.version }}
            </div>
            <div class="release-date">
              Released {{ release.date | formatDate('MMMM D') }}
            </div>
            <div
              v-if="currentRelease.version === release.version"
              class="release-current"
            >
              This is your version
            </div>
          </div>
          <div class="release-details is-left">
            <div class="release-summary">
              {{ release.summary }}
            </div>
            <div class="release-notes">
              <div
                v-for="(note, index) in release.notes"
                class="release-note"
                :key="index"
              >
                <span>{{ note }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { BridgeAPI } from '../bridge'

export default {
  name: 'news',
  data() {
    return {
      releases: [
        {
          version: '2.0.0',
          summary: "Version 2.0 is here!",
          notes: [
            "Recent performance tweaks",
            "Fucking leo fucking design updates",
            "Fixed latest bug with downloading Likezoid"
          ],
          date: new Date(),
        },
        {
          version: '1.0.59',
          summary: "Fixes",
          notes: [
            "Recent performance tweaks",
            "Fixed latest bug"
          ],
          date: new Date(),
        },
        {
          version: '1.8.0',
          summary: "Fixes",
          notes: [
            "Recent performance tweaks",
            "Smashing bugs"
          ],
          date: new Date(),
        }
      ]
    }
  },
  computed: {
    currentRelease() {
      return {
        version: this.getLikezoidVersion()
      }
    }
  },
  methods: {
    getLikezoidVersion () {
      return BridgeAPI && BridgeAPI.getLikezoidVersion && BridgeAPI.getLikezoidVersion();
    },
  }
}
</script>

<style lang="scss" scoped>
.release.el-card:not(.dialog) {
  background: #f8f9fa;
  border: none;
  
  ::v-deep .el-card__body {
    display: flex;
    padding: 17px 29px;
    height: 100px;
  }

  .release-version {
    width: 289px;
    font-size: 14px;

    .release-version-number {
      margin-top: 7px;
      font-size: 35px;
      font-weight: 700;
    }

    .release-date {
      margin-top: 10px;
      color: #86899c;
    }

    .release-current {
      margin-top: 5px;
      color: #8652f6;
      font-weight: 700;
    }
  }

  .release-details {
    font-size: 14px;
    
    .release-summary {
      line-height: 38px;
      font-weight: 600;
    }

    .release-notes {
      .release-note {
        color: #86899c;
        line-height: 22px;

        &:before {
          content: '';
          display: inline-block;
          margin-right: 9px;
          width: 10px;
          height: 8px;
          background-image: url('../assets/img/check.svg');
          vertical-align: middle;
        }

        span {
          vertical-align: middle;
        }
      }
    }
  }

  &:hover {
    background: #fff;
  }

  &:not(:first-child) {
    margin-top: 10px;
  }
}
</style>